import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { IMAGES, scrollToBuy } from '../utils/constants';
const HIGHLIGHTS = ['1 Main Box Set', '5 Strategic Bonuses', '6 Complete Modules', 'Professional Coaches', 'Individual, Pair & Group Training'];
export function Hero() {
  return <header className="w-full bg-white" data-id="element-109" data-mp="129h6c3bjvskt">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-5 text-center sm:px-6 lg:py-7" data-id="element-110" data-mp="128607wumu8qj">
        <span className="mb-2 inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand/10 px-3 py-1 font-head text-[10px] font-semibold uppercase tracking-wider text-brand-dark sm:text-xs" data-id="element-111" data-mp="xaxfppm0hsm4">
          <span className="h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" data-id="element-112" data-mp="nbygexn4z9bs" />
          The #1 Ready-To-Coach System For Padel Coaches
        </span>

        <h1 className="font-display text-4xl uppercase leading-[0.95] text-charcoal sm:text-5xl lg:text-6xl" data-id="element-113" data-mp="381xlmzcsr4ap">
          Have your next padel session ready{' '}
          <span className="text-brand" data-id="element-114" data-mp="3j6g1pzwctvil">in under 5 minutes.</span>
        </h1>

        <p className="mt-2 max-w-2xl text-[13px] leading-snug text-softgray sm:text-[15px]" data-id="element-115" data-mp="3o73qeex4209n">
          Your complete 6-in-1 professional padel coaching system: advanced progressions,
          court-ready drills, session planning, complete training sessions, tactical development,
          and player assessment tools.
        </p>

        <button type="button" onClick={scrollToBuy} className="mt-3 block w-full transition hover:opacity-95" aria-label="Get Padel Coach Pro now" data-id="element-116" data-mp="358rc6erce077">
          <img src={IMAGES.boxSet} alt="Padel Coach Pro complete 6-in-1 box set with six modules and five bonuses" className="mx-auto w-full max-w-2xl" loading="eager" data-id="element-117" data-mp="2viy1dfz0xp40" />
        </button>

        <ul className="mt-2 flex flex-wrap justify-center gap-x-3 gap-y-1" data-id="element-118" data-mp="2ljpbozb6ywng">
          {HIGHLIGHTS.map(item => <li key={item} className="flex items-center gap-1.5 font-head text-[11px] font-semibold uppercase text-charcoal sm:text-sm" data-id="element-119" data-mp="s3mahuslbkuo">
              <CheckCircle2Icon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-120" data-mp="id9soac5u5s8" />
              {item}
            </li>)}
        </ul>

        <div className="mt-4 flex w-full flex-col items-center" data-id="element-121" data-mp="1b0vwnjpavcfm">
          <CtaButton data-id="element-122" data-mp="1b0duy7jvc60b" />
          <TrustRow className="mt-2" data-id="element-123" data-mp="1ayjilhmnxm7u" />
        </div>
      </div>
    </header>;
}